module.exports = __webpack_public_path__ + "static/media/lan_access_free.b902e951.svg";